
const MUDU_HOST = "https://mudu.tv/live/watch/";

const DIST_IMAGE_HOST = "https://www.dellemc-solution.com/dtf-i";
const DIST_API_HOST = "https://www.dellemc-solution.com/dtf-b/api";

const UAT_IMAGE_HOST = "https://uat.dellemc-solution.com/dtf-i";
const UAT_API_HOST = "https://uat.dellemc-solution.com/dtf-b/api";

const DEV_IMAGE_HOST = "http://local.dellemc-solution.com/dtf-i";
const DEV_API_HOST = "http://local.dellemc-solution.com/dtf-b/api";

export default {MUDU_HOST,DIST_IMAGE_HOST,DEV_IMAGE_HOST,UAT_IMAGE_HOST,DIST_API_HOST,DEV_API_HOST,UAT_API_HOST};
